<template>
    <div class="report-container">
        <div class="circle-decoration"></div>

        <header class="header-section">
            <h1 class="year-text">2026</h1>
            <h2 class="brand-name">富学宝典</h2>
            <div class="report-badge">第三季度学习报告</div>
            <p class="slogan">坚持学习的人 · 永葆青春</p>
            <p class="slogan pc-only-hint">(请使用富学宝典APP扫码查看)</p>
        </header>
        <main v-show="false" class="main-content">
            <div class="input-group" :class="{ 'is-focused': isFocused }">
                <input class="job-input" placeholder="请输入工号" v-model="jobNo" @focus="isFocused = true"
                    @blur="isFocused = false" type="text">
                <div class="input-line"></div>
            </div>
            <button class="submit-btn" @click="debouncedSubmit" :disabled="!jobNo">
                <span>LET'S GO</span>

                <div class="btn-glow"></div>
            </button>
        </main>

        <footer class="footer-info" v-show="footerVisible">
            <p>版权所有：富泰华工业（深圳）有限公司</p>
            <p>备案号：<a href="https://beian.miit.gov.cn">粤ICP备13021698号</a></p>
        </footer>
    </div>
</template>

<script>
import jieliufa from '@/utils/jieliufa'

export default {
    data() {
        return {
            jobNo: '',
            isFocused: false,
            footerVisible: true,
            originalHeight: 0
        }
    },
    computed: {
        // 使用节流包装提交方法
        debouncedSubmit() {
            return jieliufa.throttle(() => {
                this.submitJobNo()
            }, 1000)
        }
    },
    mounted() {
        this.originalHeight = window.innerHeight;
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            // 兼容移动端键盘弹出遮挡
            this.footerVisible = window.innerHeight >= this.originalHeight - 100;
        },
        submitJobNo() {
            if (!this.jobNo.trim()) {
                this.$message({
                    message: "请输入工号",
                    type: "warning",
                    center: true
                })
                return
            }
            this.$emit('inputJobNo', this.jobNo)
        }
    }
}
</script>

<style scoped>
/* ==========================================================================
   年度报告风格 · 深邃星空开场页（参考支付宝/网易云年度报告）
   ========================================================================== */
.report-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background:
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26May/icon.png") 49% calc(80% + 20px) no-repeat,
        url("../../assets/26September/bg.png") no-repeat center / cover;
    background-size: 110px 35px, 68%, cover;
    background-color: #1a0810;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #2d1505;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.report-container * {
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

/* 底部光晕装饰 */
.circle-decoration {
    position: absolute;
    width: 420px;
    height: 420px;
    left: 50%;
    bottom: -260px;
    transform: translateX(-50%);
    background: radial-gradient(circle, rgba(74, 158, 255, 0.22) 0%, rgba(91, 124, 255, 0.10) 45%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
}

.pc-only-hint {
    display: none;
}

/* 头部视觉 */
.header-section {
    margin-top: 13vh;
    text-align: center;
    z-index: 2;
    animation: fadeInDown 0.9s cubic-bezier(0.16, 1, 0.3, 1);
}

.year-text {
    font-size: 88px;
    font-weight: 900;
    margin: 0;
    line-height: 1;
    letter-spacing: 6px;
    color: #5bb3f2;
    /* background: linear-gradient(180deg, #7cc8ff 0%, #4a9eff 45%, #2d7dd6 100%); */
    /* -webkit-background-clip: text; */
    /* background-clip: text; */
    /* -webkit-text-fill-color: transparent; */
    /* filter: drop-shadow(0 2px 6px rgba(239, 237, 237, 0.6)); */
}

.brand-name {
    font-size: 32px;
    font-weight: bold;
    color: #2d1505;
    margin: 14px 0;
    letter-spacing: 4px;
    text-shadow: 0 2px 16px rgba(0, 0, 0, 0.4);
}

.report-badge {
    display: inline-block;
    background: linear-gradient(135deg, rgba(187, 215, 246, 0.22), rgba(76, 212, 239, 0.12));
    border: 1px solid rgba(74, 158, 255, 0.55);
    color: #55a8eb;
    font-weight: 600;
    padding: 7px 28px;
    border-radius: 50px;
    font-size: 15px;
    letter-spacing: 2px;
    box-shadow: 0 0 24px rgba(74, 158, 255, 0.22), inset 0 0 12px rgba(74, 158, 255, 0.12);
    margin: 12px 0;
}

.slogan {
    font-size: 15px;
    color: rgba(45, 20, 5, 0.9);
    font-weight: 400;
    letter-spacing: 3px;
}

/* 主体交互区 */
.main-content {
    width: 85%;
    max-width: 320px;
    margin-top: 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
    animation: fadeInUp 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.15s both;
}

.input-group {
    width: 100%;
    position: relative;
    margin-bottom: 32px;
    transition: all 0.3s ease;
}

.job-input {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.07);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    padding: 16px;
    border-radius: 14px;
    font-size: 17px;
    text-align: center;
    outline: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: #2d1505;
    letter-spacing: 1px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.job-input::placeholder {
    color: rgba(45, 20, 5, 0.4);
    letter-spacing: 2px;
}

.input-line {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #4a9eff, transparent);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-50%);
    border-radius: 2px;
}

.input-group.is-focused .input-line {
    width: 90%;
}

.input-group.is-focused .job-input {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(74, 158, 255, 0.6);
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(74, 158, 255, 0.18);
}

.submit-btn {
    position: relative;
    width: 100%;
    padding: 16px 40px;
    border: none;
    background: linear-gradient(135deg, #a8d8ff 0%, #4a9eff 45%, #2d7dd6 100%);
    color: #ffffff;
    border-radius: 50px;
    font-size: 17px;
    font-weight: 800;
    letter-spacing: 3px;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s;
    box-shadow: 0 10px 30px rgba(227, 155, 63, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.submit-btn:hover:not(:disabled) {
    box-shadow: 0 14px 38px rgba(74, 158, 255, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
}

.submit-btn:active:not(:disabled) {
    transform: scale(0.98);
}

.submit-btn:disabled {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: none;
    cursor: not-allowed;
    color: rgba(45, 20, 5, 0.28);
    letter-spacing: 3px;
}

.btn-glow {
    position: absolute;
    top: 0;
    left: -100%;
    width: 60%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent);
    transform: skewX(-20deg);
    animation: sweep 3.5s infinite;
}

@keyframes sweep {
    0% { left: -100%; }
    40% { left: 160%; }
    100% { left: 160%; }
}

@keyframes fadeInDown {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

.footer-info {
    position: fixed;
    bottom: 22px;
    text-align: center;
    font-size: 12px;
    color: rgba(20, 10, 3, 0.45);
    line-height: 1.7;
    z-index: 2;
}

.footer-info a {
    color: rgba(6, 3, 2, 0.85);
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
    padding-bottom: 1px;
    transition: all 0.3s;
}

.footer-info a:hover {
    color: #4a9eff;
    border-bottom-color: #4a9eff;
}


/* ==========================================================================
   PC端响应式适配
   ========================================================================== */
@media screen and (min-width: 1024px) {
    .report-container {
        background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26September/code.png") 50% calc(72% + 10px) no-repeat,
            url("../../assets/26September/pcbg.png") no-repeat center / cover;
        background-size: 110px 35px, 130px 130px, cover;
        background-color: #1a0810;
    }

    .header-section {
        margin-top: 12vh;
        margin-bottom: 26px;
    }

    .year-text {
        font-size: 120px;
        letter-spacing: 10px;
    }

    .brand-name {
        font-size: 44px;
        margin: 18px 0;
    }

    .report-badge {
        font-size: 17px;
        padding: 8px 36px;
        margin: 10px 0 20px 0;
    }

    .pc-only-hint {
        display: block;
        margin-top: 15px;
        color: rgba(45, 20, 5, 0.9);
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 2px;
    }

    .main-content {
        max-width: 420px;
        width: 100%;
        margin-top: 0;
        padding: 40px 46px;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(74, 158, 255, 0.22);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border-radius: 24px;
        box-shadow:
            0 25px 60px -12px rgba(0, 0, 0, 0.6),
            inset 0 1px 0 rgba(255, 255, 255, 0.08);
    }

    .input-group {
        margin-bottom: 28px;
    }

    .job-input {
        font-size: 18px;
        padding: 17px;
    }

    .submit-btn {
        font-size: 18px;
        padding: 17px;
    }

    .footer-info {
        bottom: 26px;
        font-size: 13px;
        letter-spacing: 0.5px;
        color: rgba(45, 20, 5, 0.45);
    }
}
</style>